import { AfterViewInit, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UsersService } from '@core/services/users.service';
import { UserInfoService } from '@core/services/user-info.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-profile-view',
  templateUrl: './profile-view.component.html',
  styleUrls: ['./profile-view.component.scss']
})
export class ProfileViewComponent implements OnInit, AfterViewInit {
    urlParams;
    authUser;
    profileUser;
    subscriptions: Subscription[] = [];
    ownProfile = false;
  constructor(
      private route: ActivatedRoute,
      private usersService: UsersService,
      private _userInfoService: UserInfoService,
  ) { }

  ngOnInit() {
      this.urlParams = this.route.snapshot.queryParams;
      this._getAuthInfo();
      this.getSubscriber();
  }
    private _getAuthInfo() {
        this._userInfoService._userInfo.subscribe((data) => {
            this.authUser = data;
        });
    }

    getSubscriber() {
        this.usersService.getSub({
            user_id: JSON.parse(this.urlParams.id)
        }).subscribe(dt => {
                this.profileUser = dt.user;
        });

    }

    ngAfterViewInit() {
        console.log('profile-view');

    }

}
